/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { cached } from '@glimmer/tracking';
import {
  chipClass,
  disputeState,
} from 'uplisting-frontend/utils/protection-status';
import type { ModelRegistry } from 'ember-data/types/registries/model';

interface IArgs {
  dispute: ModelRegistry['dispute'];
}

interface UiProtectionDisputePanelBodySignature {
  Element: HTMLDivElement;

  Args: IArgs;
}

export default class UiProtectionDisputePanelBodyComponent extends Component<UiProtectionDisputePanelBodySignature> {
  @cached
  get statusClass(): string {
    return chipClass(disputeState(this.args.dispute.status));
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Ui::Protection::DisputePanel::Body': typeof UiProtectionDisputePanelBodyComponent;
    'ui/protection/dispute-panel/body': typeof UiProtectionDisputePanelBodyComponent;
  }
}
